document.addEventListener("DOMContentLoaded", function() {
  const newsletterBtns = document.querySelectorAll(".btn-newsletter");
  const currentLang = document.querySelector("html").getAttribute("lang");

  if (newsletterBtns.length > 0) {
    newsletterBtns.forEach(btn => {
      btn.addEventListener("click", handleNewsletter);
    });
  }
  function handleNewsletter(event) {
    event.preventDefault();
    // Display language accurate Klavyio form
    window._klOnsite = window._klOnsite || [];

    if (currentLang === "en") {
      //window._klOnsite.push(["openForm", "Sxi74N"]);
    } else {
      window._klOnsite.push(["openForm", "USxwwz"]);      
    }    
  }
});
